import type { ObjectValues } from '@repo/common';

export const InfoModal = {
  CANCEL_VERIFICATION: 'CANCEL_VERIFICATION',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
} as const;

export type InfoModalValues = ObjectValues<typeof InfoModal>;
